'use strict';

(function () {
	'use strict';

	civilRegister.$inject = ['$http', '$q', 'baseService', 'appConfig'];
	angular.module('app').factory('civilRegister', civilRegister);

	function civilRegister($http, $q, baseService, appConfig) {
		'ngInject';

		var service = {
			getEntries: getEntries,
			getMunicipalUnits: getMunicipalUnits,
			getYearRange: getYearRange,
			getFormDefaults: getFormDefaults,
			getLatestEntry: getLatestEntry
		};

		return service;

		/**
   * 
   * @param {*} from 
   * @param {*} to 
   */
		function getEntries(from, to) {

			var params, responseTransformers;

			params = {
				date: ['gte.' + from.format(), 'lte.' + to.format()],
				order: 'date.asc'
			};

			return $http.get(appConfig.apiUrl + '/civil_register', {
				params: params,
				transformResponse: $http.defaults.transformResponse.concat(baseService.createDateAttrTransformer('date'))
			}).then(function (response) {
				return response.data;
			});
		}

		function getLatestEntry() {
			return baseService.getColumnMinOrMaxValue('civil_register', 'date', false, { select: 'date' }).then(function (rsp) {
				return $http.get(appConfig.apiUrl + '/civil_register', { params: { date: 'eq.' + rsp.date } });
			}).then(function (rsp) {
				var summary = {};

				var data = _(rsp.data);

				summary.date = data.head().date;
				summary.male_births = data.sumBy('male_births');
				summary.female_births = data.sumBy('female_births');
				summary.births = summary.male_births + summary.female_births;

				summary.male_deaths = data.sumBy('male_deaths');
				summary.female_deaths = data.sumBy('female_deaths');
				summary.deaths = summary.male_deaths + summary.female_deaths;

				summary.religious_weddings = data.sumBy('religious_weddings');
				summary.civil_weddings = data.sumBy('civil_weddings');
				summary.civil_unions = data.sumBy('civil_unions');
				summary.divorces = data.sumBy('divorces');
				summary.weddings = summary.religious_weddings + summary.civil_weddings;

				return summary;
			});
		}

		/**
   * 
   */
		function getFormDefaults() {
			return $q.when({
				from: moment().subtract(5, 'years').startOf('year'),
				to: moment().endOf('year')
			});
		}

		/**
   * 
   */
		function getYearRange() {
			return baseService.getColumnRange('civil_register', 'date').then(function (response) {
				return {
					min: moment(response.min.date).startOf('year'),
					max: moment(response.max.date).endOf('year')
				};
			});
		}

		function getMunicipalUnits() {
			return $http.get(appConfig.apiUrl + '/municipal_department').then(function (response) {
				return response.data;
			});
		}

		/************************************************/

		function getMunicipalUnits() {
			var deferred = $q.defer();

			$http.get(appConfig.apiUrl + '/municipal_department', {
				params: {
					order: 'name_el.asc'
				}
			}).then(function (response) {
				deferred.resolve(response.data);
			}, function (response) {
				deferred.reject(response.data);
			});

			return deferred.promise;
		}

		function getCivilRegistryDataPerMunicipalUnit(from, to) {
			var deferred = $q.defer(),
			    params,
			    from = moment(from).startOf('year'),
			    to = moment(to).endOf('year'),
			    responseTransformers = [];

			params = {
				date: ['gte.' + from.format(), 'lte.' + to.format()],
				order: 'date.asc'
			};

			responseTransformers.push(transformMeasurements);

			$http.get(appConfig.apiUrl + '/civil_register', {
				params: params,
				transformResponse: $http.defaults.transformResponse.concat(responseTransformers)
			}).then(function (response) {
				var data = {};

				angular.forEach(response.data, function (entry, index) {
					if (typeof data[entry.municipal_department_id] == 'undefined') {
						data[entry.municipal_department_id] = [];
					}
					data[entry.municipal_department_id].push(entry);
				});

				deferred.resolve(data);
			}, function (response) {
				deferred.reject(response.data);
			});

			return deferred.promise;
		}

		// function fillInMissingEntries(entries, dateAttribute, from, to, granularity, creator) {
		// 	var current, previous, injected, newEntries;

		// 	previous
		// }


		function getDepartments() {
			var deferred = $q.defer();

			$http.get(appConfig.apiUrl + '/municipal_department', {
				params: {
					order: 'name_el.asc'
				},
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				}
			}).then(function (response) {
				deferred.resolve(response.data);
			}, function (response) {
				deferred.reject(response.data);
			});

			return deferred.promise;
		}

		function getMinMaxYear(start, end) {
			var deferred = $q.defer();

			$q.all({
				min: getMinOrMaxYear(true),
				max: getMinOrMaxYear(false)
			}).then(function (data) {
				deferred.resolve(data);
			}, function (data) {
				deferred.reject(data);
			});

			return deferred.promise;
		}

		function getMinOrMaxYear(min) {
			var deferred = $q.defer();
			var order;

			order = 'date.desc';
			if (min == true) {
				order = 'date.asc';
			}

			$http.get(appConfig.apiUrl + '/civil_register', {
				params: {
					select: 'date',
					order: order,
					limit: 1
				},
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				}
			}).then(function (response) {
				var date = moment();

				if (response.data.length == 1) {
					if (min) {
						date = moment(response.data[0].date).startOf('year');
					} else {
						date = moment(response.data[0].date).endOf('year');
					}
				}

				deferred.resolve(date);
			}, function (response) {
				deferred.reject(response.data);
			});

			return deferred.promise;
		}

		function transformMeasurements(data, headersGetter, status) {
			angular.forEach(data, function (entry, index) {
				entry.date = new Date(entry.date);
			});

			return data;
		}
	}
})();